import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { momentWithTimezone } from 'redux/modules/shop/helpers';
const classNames = require('classnames');

interface IProps {
	t?: (key: string) => string;
	setSelectedDate: (date: string) => void;
	date: string;
	slotsAvailable?: number;
	timezone?: string;
	selectedDate: string;
	showMonthAndYear: boolean;
	isFirstDayAfterFirstElement: boolean;
	isFirstElement?: boolean;
	isLastElement?: boolean;
}

interface IState {}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class DateSelectionCard extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		const {
			slotsAvailable,
			date,
			t,
			timezone,
			showMonthAndYear,
			isFirstDayAfterFirstElement,
			selectedDate,
			isFirstElement,
			isLastElement,
		} = this.props;
		let isActive: boolean = false;

		const dataLoaded = slotsAvailable !== undefined;

		if (slotsAvailable && date === selectedDate) {
			isActive = true;
		}

		return (
			<>
				<div className={classNames(`dateSelectionCardDesktop`, { noData: !dataLoaded })}>
					{showMonthAndYear ? (
						<div className={`dateSelectionCard__monthAbove ${isFirstDayAfterFirstElement ? 'first' : ''}`}>
							{momentWithTimezone(timezone, date).format('MMMM yyyy')}
						</div>
					) : null}
					<div
						className={`dateSelectionCard ${slotsAvailable ? 'availableSlots' : 'noSlots'} ${isActive ? 'active' : ''}`}
						onClick={() => {
							slotsAvailable && this.props.setSelectedDate(date);
						}}
					>
						<p className="dateSelectionCard__month">{momentWithTimezone(timezone, date).format('Do')}</p>
						<p className="dateSelectionCard__day">{momentWithTimezone(timezone, date).format('ddd')}</p>
						<p className="dateSelectionCard__slots">
							{slotsAvailable
								? `${slotsAvailable} ${t('BookAppointment_Schedule_Count_Mobile')}`
								: `${t('BookAppointment_Schedule_Count_No_Slots_Mobile')}`}
						</p>
					</div>
				</div>
				<div
					className={classNames(`dateSelectionCardMobile`, {
						first: isFirstElement,
						last: isLastElement,
						noData: !dataLoaded,
					})}
				>
					{showMonthAndYear ? (
						<div className="dateSelectionCard__monthAbove">
							<div className="dateSelectionCard__monthAbove__inner">
								{momentWithTimezone(timezone, date).format('MMMM yyyy')}
							</div>
						</div>
					) : null}
					<div
						className={`dateSelectionCard ${slotsAvailable ? 'availableSlots' : 'noSlots'} ${isActive ? 'active' : ''}`}
						onClick={() => {
							slotsAvailable && this.props.setSelectedDate(date);
						}}
					>
						<p className="dateSelectionCard__month">{momentWithTimezone(timezone, date).format('Do')}</p>
						<p className="dateSelectionCard__day">{momentWithTimezone(timezone, date).format('ddd')}</p>
						<p className="dateSelectionCard__slots">
							{slotsAvailable
								? `${slotsAvailable} ${t('BookAppointment_Schedule_Count_Mobile')}`
								: `${t('BookAppointment_Schedule_Count_No_Slots_Mobile')}`}
						</p>
					</div>
				</div>
			</>
		);
	}
}

export default DateSelectionCard;
